import { API_URL, TOAST_STYLE_ERROR, TOAST_STYLE_SUCCESS } from './constants';
import axios from 'axios';
import auth from '../Auth';
import { toast } from 'react-toastify';

// Set up a reusable axios instance
const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
    // Add other headers here
  }
});

export const saveProviderSecret = async (secretData) => {
  try {
    const response = await apiClient.post(`/provider_secrets`, secretData, {
      headers: {
        Authorization: `Bearer ${await auth.getIdToken()}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error saving provider secret:', error);
    throw error;
  }
};


export const testPromptAPI = async (context, prompt_data, behavior_name) => {
  try {
    const response = await apiClient.post(
      `/logs`,
      {
        context: context,
        prompt_data: prompt_data,
        behavior_name: behavior_name
      },
      {
        headers: {
          Authorization: `Bearer ${await auth.getIdToken()}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error saving provider secret:', error);
    throw error;
  }
};

export const fetchProviderSecrets = async () => {
  try {
    const response = await apiClient.get(`/provider_secrets`, {
      headers: {
        Authorization: `Bearer ${await auth.getIdToken()}`
      }
    });
    return response.data.items;
  } catch (error) {
    console.error('Error fetching secrets:', error);
    throw error;
  }
};

export const deleteProviderSecret = async (id) => {
  try {
    const response = await apiClient.delete(`/provider_secrets?secret_id=${id}`, {
      headers: {
        Authorization: `Bearer ${await auth.getIdToken()}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting provider secret:', error);
    throw error;
  }
};

  export const apiFetchModels = async () => {
  try {
    const response = await apiClient.get(`/models`, {
      headers: {
        Authorization: `Bearer ${await auth.getIdToken()}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching models:', error);
    throw error;
  }
};